import api from '../utils/api';

// Fetch all Late Books
export const getLateBooks = async (headers) => {
  try {
    const response = await api.get('/api/late-books/late-books', headers);
    console.log("getLateBooks ", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching late books:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific Late Book by ID
export const getLateBookById = async (id, headers) => {
  try {
    const response = await api.get(`/api/late-books/late-books/${id}`, headers);
    console.log("get Late Book by id ", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching late book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new Late Book
export const createLateBook = async (lateBookData, headers) => {
  try {
    const response = await api.post('/api/late-books/late-books', lateBookData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating late book:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing Late Book
export const updateLateBook = async (id, lateBookData, headers) => {
  try {
    const response = await api.put(`/api/late-books/late-books/${id}`, lateBookData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating late book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a Late Book
export const deleteLateBook = async (id, headers) => {
  try {
    const response = await api.delete(`/api/late-books/late-books/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting late book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
